import { render, staticRenderFns } from "./discordTalkroom2.vue?vue&type=template&id=1891f693&scoped=true"
import script from "./discordTalkroom2.vue?vue&type=script&lang=js"
export * from "./discordTalkroom2.vue?vue&type=script&lang=js"
import style0 from "./discordTalkroom2.vue?vue&type=style&index=0&id=1891f693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1891f693",
  null
  
)

export default component.exports